exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".projects-server-table thead tr th:first-child {\n  width: 90%;\n}\n", ""]);

// exports
